const Vue = require('vue')

Vue.component('ui-avatar', require('components/ui/Avatar.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/avatar.js